module.exports = __webpack_public_path__ + "img/overseas-business-wechat-official-accounts_3.385942d3.png";